import { useOrgId } from "../../../components/hooks";
import { SessionsView } from "../../../components/views";
export const SessionsPage = () => {
  const orgId = useOrgId();
  return <SessionsView orgId={orgId === -1 ? undefined : orgId} limit={8} />;
};
